import type { TooltipOptions } from "highcharts";
import { renderToStaticMarkup } from "react-dom/server";

import { tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";

export const tooltipConfig: TooltipOptions = {
    outside: true,
    headerFormat: "",
    useHTML: true,
    ...tooltipContainerConfig().tooltip,
    pointFormatter() {
        return renderToStaticMarkup(
            <LegendWithOneLineBulletFlex
                text={this.name}
                value={`${this.y?.toFixed(2)}%`}
                labelColor={this.color as string}
            />,
        );
    },
};
